import './styling/main.less';
import { createApp } from 'vue';

import router, { initRouter } from './router';
import App from './App.vue';
import coreConfig from './core/config';
import projectConfig from './project';
import { routes } from '@/router/routes';
import GTMBasics from './project/tracking/gtm/GTM.basics';

const app = createApp(App);

if (import.meta.env.DEV) {
    app.config.performance = true;
}

initRouter(routes);

coreConfig(app)
    .then(() => {
        projectConfig(app)
            .then(() => {
                    app.use(router);
                    router.isReady().then(() => app.mount('#app'));
                });

        GTMBasics.init();
        GTMBasics.setupPostLoginTracking();
    });
